export default __webpack_public_path__ + "media/female.e92ba68e.svg";